var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIconFolderPlus(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 52,
    height: 52,
    viewBox: "0 0 52 52",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M28.1668 15.1667L25.7498 10.3327C25.0542 8.94141 24.7064 8.24575 24.1875 7.73752C23.7286 7.28808 23.1755 6.94628 22.5683 6.73684C21.8817 6.5 21.1039 6.5 19.5485 6.5H11.2668C8.83993 6.5 7.62649 6.5 6.69954 6.97231C5.88417 7.38776 5.22125 8.05067 4.8058 8.86604C4.3335 9.79299 4.3335 11.0064 4.3335 13.4333V15.1667",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M26.0002 36.8332V23.8332M19.5002 30.3332H32.5002M4.3335 15.1665H37.2668C40.9072 15.1665 42.7273 15.1665 44.1178 15.875C45.3408 16.4981 46.3352 17.4925 46.9584 18.7156C47.6668 20.106 47.6668 21.9262 47.6668 25.5665V35.0998C47.6668 38.7402 47.6668 40.5603 46.9584 41.9508C46.3352 43.1738 45.3408 44.1682 44.1178 44.7914C42.7273 45.4998 40.9072 45.4998 37.2668 45.4998H14.7335C11.0932 45.4998 9.27298 45.4998 7.88256 44.7914C6.6595 44.1682 5.66513 43.1738 5.04195 41.9508C4.3335 40.5603 4.3335 38.7402 4.3335 35.0998V15.1665Z",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconFolderPlus);
export default __webpack_public_path__ + "static/media/IconFolderPlus.3bc67b51ee5af3caf24e727927e3e810.svg";
export { ForwardRef as ReactComponent };